var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanydataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#262a2e",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.62-136.92v-650l190-137.7 189.99 137.7v110h390.77v540H94.62Zm59.99-60h100.01v-100H154.61v100Zm0-160h100.01v-100H154.61v100Zm0-160h100.01v-100H154.61v100Zm0-160h100.01v-100H154.61v100Zm160 0h100.01v-100H314.61v100Zm0 480h490.78v-420H314.61v420Zm247.7-260v-60H710v60H562.31Zm0 160v-60H710v60H562.31Zm-147.69-160v-60h59.99v60h-59.99Zm0 160v-60h59.99v60h-59.99Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanydataIcon);
export default __webpack_public_path__ + "static/media/companydata_icon.6264ce9159c5b5edaef300c3382dabb5.svg";
export { ForwardRef as ReactComponent };